<template>
  <div>
    <v-card outlined class="app-card" id="veiculo">
      <v-card-title class="app-card-title">Veículo</v-card-title>
      <v-card-text class="app-card-content">
        <v-row no-gutters v-if="veiculo">
          <v-col :md="4" :sm="4" :xs="12" cols="12">
            <strong class="info-text">
              Placa:
              <em>{{ veiculo.placa }}</em>
            </strong>
          </v-col>
          <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 text-md-left">
            <strong class="info-text">
              Renavam:
              <em>{{ veiculo.renavam }}</em>
            </strong>
          </v-col>
          <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 text-md-right">
            <strong class="info-text">
              N° Chassi:
              <em>{{ veiculo.chassi }}</em>
            </strong>
          </v-col>
          <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 text-md-left">
            <strong class="info-text">
              UF:
              <em>{{ veiculo.uf }}</em>
            </strong>
          </v-col>
          <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 text-md-left">
            <strong class="info-text">
              Ano Fabricação:
              <em>{{ veiculo.anoFabricacao }}</em>
            </strong>
          </v-col>
          <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 text-md-right">
            <strong class="info-text">
              Lotação:
              <em>
                {{ veiculo.quantidadeSentados }} Sentados e
                {{ veiculo.quantidadeEmPe == null ? 0 : veiculo.quantidadeEmPe }}
                Em pé
              </em>
            </strong>
          </v-col>
          <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 text-md-left">
            <strong class="info-text">
              Marca/Modelo:
              <em>{{ veiculo.marcaModelo }}</em>
            </strong>
          </v-col>
          <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 text-md-left">
            <strong class="info-text">
              Tipo de Veículo:
              <em>{{ veiculo.tipoVeiculo }}</em>
            </strong>
          </v-col>
        </v-row>
        <div class="loading" v-if="isLoading">
          <v-progress-circular :size="25" color="primary" indeterminate></v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
    <AutorizacaoList :veiculoTransportadoraId="veiculo.idVeiculoTransportadora" v-if="veiculo" />
  </div>
</template>

<script>
import AutorizacaoList from "../autorizacao/AutorizacaoList";
import VeiculoService from "@/services/veiculo.service";

export default {
  components: {
    AutorizacaoList
  },
  data() {
    return {
      veiculo: null,
      isLoading: false
    };
  },
  methods: {
    loadVeiculo() {
      const { veiculoId } = this.$route.params;
      this.isLoading = true;
      VeiculoService.findByVeiculoTransportadora(veiculoId).subscribe(
        res => {
          this.veiculo = res;
          this.isLoading = false;
        },
        error => {
          this.isLoading = false;
        }
      );
    }
  },
  mounted() {
    this.loadVeiculo();
  }
};
</script>

<style></style>vue
